module.exports = __webpack_public_path__ + "img/bp_gift2.468d4532.png";